import request, { Response } from "superagent";

export interface XHRApiAuth {
    headers: [string, string][];
    baseUrl: string;
    verifier: () => void;
}

function _applyApiAuth(req, apiAuth: XHRApiAuth) {
    apiAuth.verifier(); // throws if problem

    apiAuth.headers.forEach(function ([name, value]) {
        req.set(name, value);
    });
}

export async function makeRequest(
    apiAuth: XHRApiAuth,
    method: "GET" | "POST",
    url: string,
    data?: any,
): Promise<Response> {
    const fullUrl = apiAuth.baseUrl + url;
    const req = request(method, fullUrl);
    req.withCredentials();
    req.set("X-Requested-With", "XMLHttpRequest");

    _applyApiAuth(req, apiAuth);

    if (data) {
        if (method === "GET") {
            req.query(data);
        } else {
            req.send(data);
        }
    }

    try {
        const res: Response = await req;
        return res;
    } catch (err) {
        // fluxible-router is checking "statusCode" instead of "status"
        err.statusCode = err.status;
        throw err;
    }
}

const DEFAULT_NUMBER_OF_RETRIES = 1;

/**
 * Try to make request - if it fails with crossDomain error, retry it
 *
 * @param apiAuth
 * @param method {string}
 * @param url {string}
 * @param data {object}
 */
export async function makeRequestWithRetries(
    apiAuth: XHRApiAuth,
    method: "GET",
    url: string,
    data?: any,
): Promise<Response> {
    const numOfRetries = DEFAULT_NUMBER_OF_RETRIES;

    let i = 0;
    while (true) {
        try {
            const res = await makeRequest(apiAuth, method, url, data);
            return res;
        } catch (err) {
            if (err.crossDomain && i < numOfRetries) {
                i++;

                // Retry request
                continue;
            }

            throw err; // Re-throw
        }
    }
}
